import { api } from "@/api"

export type SelfChangePasswordIn = {
  currentPassword?: string | null
  password: string
}

export const selfChangePassword = async (
  params: SelfChangePasswordIn
) => {
  const { body } = await api.post(
    "/users/self/change-password/",
    { body: params }
  )
  return body
}
